<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">+增加线上课程</Button>
            <cite>|</cite>
            在线课程管理
          </Col>
          <Col span="5">
            <Input search enter-button placeholder="输入课程名称搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="ID" :show-tooltip-when-overflow="true" width="60"></el-table-column>
        <el-table-column prop="img" label="课程封面图" :show-tooltip-when-overflow="true" width="90">
          <template slot-scope="scope">
            <img :src="'/api/upload/online/'+scope.row.img" style="width:80px;"/>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="课程名称" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a @click="modal2=true;productId=scope.row.id">{{scope.row.productName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="guanlian" label="关联线下课" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a @click="m2.modal=true;m2.zaixian=scope.row.id">管理</a>
          </template>
        </el-table-column>
        <!--<el-table-column prop="categoryName" label="分类" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="pick" label="是否精选课" :show-tooltip-when-overflow="true">-->
          <!--<template slot-scope="scope">-->
            <!--<span v-if="scope.row.pick==1" style="color:#19be6b">精选课</span>-->
            <!--<span v-if="scope.row.pick==0">否</span>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="description" label="课程介绍" :show-tooltip-when-overflow="true"></el-table-column>-->
        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="100">
        <FormItem label="课程名称" required>
          <Input v-model="detail.productName"/>
        </FormItem>

        <FormItem label="讲师" required>
          <FieldLecturer v-model="detail.onteaid"></FieldLecturer>
        </FormItem>


        <!--<FormItem label="分类" required>-->
          <!--<FieldClassify v-model="detail.categoryId" type="线上课"></FieldClassify>-->
        <!--</FormItem>-->
        <FormItem label="课程封面图" required>
          <UploadOne  v-model="detail.img"></UploadOne>
          大小：488*310像素，100kb以内
        </FormItem>
        <FormItem label="课程介绍" required>
          <Input v-model="detail.description" type="textarea" style="font-size: 15px;" :autosize="{minRows: 6,maxRows: 50}" placeholder="课程大纲"></Input>
          <p>
            <a href="https://www.yuque.com/docs/share/31345305-d849-47d9-b1bc-39c6b8a13fe0" target="_blank">请点击查看说明</a>
          </p>
          <!--<JsonEdit :detail="detail.descObj" v-model="detail.description" type="课程介绍"></JsonEdit>-->
        </FormItem>

        <FormItem label="微信显示排序" required>
          <Input type="number" v-model="detail.sort"></Input>
          <p>数字越大排序越靠前，当数字相同时，按创建时间排序，后创建的靠前。 </p>
        </FormItem>

        <!--<FormItem label="是否精选" required>-->
          <!--<Select v-model="detail.pick">-->
            <!--<Option value="0" label="否"></Option>-->
            <!--<Option value="1" label="是"></Option>-->
          <!--</Select>-->
          <!--精选课会在小程序首页展示，最多展示4个精选课-->
        <!--</FormItem>-->

      </Form>
    </Modal>

    <Drawer title="在线课程章节管理"  width="70%" v-model="modal2">
      <Chapter :productId="productId"></Chapter>
    </Drawer>

    <Drawer title="关联线下课"  width="70%" v-model="m2.modal">
      <Guanlian :zaixian="m2.zaixian"></Guanlian>
    </Drawer>

  </div>
</template>

<script>

  import UploadOne from '@/public/upload/UploadOne'
  import FieldClassify from '@/components/common/field/FieldClassify.vue'
  import Chapter from './Chapter'
  import FieldLecturer from '@/components/common/field/FieldLecturer'
  import JsonEdit from '@/components/common/json/JsonEdit'
  import Guanlian from './Guanlian'
  export default {
    components:{UploadOne,FieldClassify,Chapter,FieldLecturer,JsonEdit,Guanlian},
    data(){
      return{
        baseUrl:'/api/product/product/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        m2:{
          modal:false,//关联课程
          zaixian:0,//线下课程
        },
        loading:false,
        modal2:false,
        productId:0,
        gl:[],//关联课程选择列表
        gls:[],//选中的关联列表
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.productName@like@'+this.serch.key);
        }
        params.push('t.productType@like@线上课');
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.productType = '线上课';
        this.detail.jsonObj = null;
        this.detail.descObj = null;

        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save?guanlian=',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          //设置一下关联
          that.modal1 = true;

        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      },

    },
    created(){
      this.load();

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/product/online/OnLineProduct.vue